import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "./authContext";

/**
 * Usage:
 *   <ProtectedRoute> ... </ProtectedRoute>
 *   <ProtectedRoute allowedRoles={["admin", "manager"]}> ... </ProtectedRoute>
 *
 * - If `allowedRoles` is omitted or empty, any signed-in user can access.
 * - Works even if auth/role are still loading.
 */
export default function ProtectedRoute({ children, allowedRoles }) {
  const auth = useAuth() || {};

  // Support both shapes your app uses in places
  const loading = !!auth.loading;
  const currentUser = auth.user ?? auth.currentUser ?? null;
  const rawRole = auth.role ?? auth.user?.role ?? "";

  // Wait for auth to resolve before checking anything
  if (loading) return null; // or a spinner

  // Not signed in -> go to login
  if (!currentUser) return <Navigate to="/login" replace />;

  // If roles were provided, enforce them safely
  if (Array.isArray(allowedRoles) && allowedRoles.length > 0) {
    const userRole = String(rawRole || "").toLowerCase().trim();
    const allowed = allowedRoles.map((r) => String(r || "").toLowerCase().trim());
    if (!allowed.includes(userRole)) {
      return <Navigate to="/unauthorized" replace />;
    }
  }

  return children;
}
